import React, { useMemo } from 'react';
import { useTranslate } from 'react-admin';
import CustomizedFilterWrapper from '../../../../base/components/customized/CustomizedFilterWrapper';
import { SelectInput, TextInput } from '../../../../base/components/ra/inputs';
import { isSystemUsers } from '../../../../services/util/auth';
import { PAYMENT_METHOD, PAYMENT_STATUS } from '../../../../constant/invoice';
import GroupSelector from '../../../../base/components/customized/common-input/GroupSelector';
import { useAuthUser } from '../../../../base/hooks';
import DateRangeInput from '../../../../base/components/guesser/date-range-input';

const PaymentFilters = () => {
  const t = useTranslate();
  const isSU = isSystemUsers();

  const statusChoices = useMemo(
    () =>
      Object.values(PAYMENT_STATUS).reduce((list, status) => {
        if (isSU || status !== PAYMENT_STATUS.WAIVED) {
          list.push({
            id: status,
            name: t(`common.paymentStatus.${status}`),
          });
        }
        return list;
      }, []),
    [t],
  );

  const methodChoices = useMemo(
    () =>
      Object.values(PAYMENT_METHOD).map((method) => ({
        id: method,
        name: t(`common.paymentMethod.${method}`),
      })),
    [t],
  );

  return (
    <CustomizedFilterWrapper>
      <TextInput source="paymentId||$eq" label="resources.payment.fields.id" />
      <DateRangeInput
        source="createdAt"
        label={t('resources.payment.fields.createdTime')}
        defaultRangeOption="date"
        hasRangeOption={false}
        showTime={false}
        allowClear={[true, true]}
        allowEmpty={[true, true]}
        ranges={[]}
        serverFormat={null}
      />
      <DateRangeInput
        source="completedAt"
        label={t('resources.payment.fields.completedTime')}
        defaultRangeOption="date"
        hasRangeOption={false}
        showTime={false}
        allowClear={[true, true]}
        allowEmpty={[true, true]}
        ranges={[]}
        serverFormat={null}
      />
      <GroupFilter />
      <SelectInput source="paymentMethod" label="resources.payment.fields.paymentMethod" choices={methodChoices} />
      <SelectInput source="paymentStatus" label="resources.payment.fields.status" choices={statusChoices} />
    </CustomizedFilterWrapper>
  );
};

export default PaymentFilters;

const GroupFilter = () => {
  const user = useAuthUser();
  const userGroupId = user.group?.id;

  return <GroupSelector source="groupId" defaultValue={userGroupId} disabled={Boolean(userGroupId)} />;
};
